import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const SearchParamsSchema = z.object({
    name: z.string().optional(),
    dateRange: z.string().optional(),
    publishedBy: z.string().optional(),
    gitTags: z.string().optional(),
    showUnavailable: z.string().optional()
});
// Will be lazy loaded from MFE
export const Route = createFileRoute('/org/$organization/$project/app/$application/versions/')({
    validateSearch: (search)=>SearchParamsSchema.parse(search),
    component: ()=>null
});
